import { PencilIcon } from "@heroicons/react/24/solid";
import { ChangeEvent } from "react";

type Props = {
  id: string;
  setFieldValue: (file: FileList, id: string) => void;
  isDisabled?: boolean;
};

function EditImageButton({ id, setFieldValue, isDisabled }: Props) {
  function handleSetImage(e: ChangeEvent<HTMLInputElement>) {
    // This is needed as by defaykt
    if (e.target.files?.length) {
      setFieldValue(e.target.files, id);
    }
  }
  return (
    <div className="absolute right-2 bottom-2 rounded-full border-2 bg-white p-2 ">
      <label htmlFor={id} className="relative cursor-pointer">
        <PencilIcon className="h-5 w-5 text-black  " />
        <input
          disabled={isDisabled}
          id={id}
          accept="image/png, image/jpeg"
          name={id}
          type="file"
          className="sr-only"
          onChange={handleSetImage}
        />
      </label>
    </div>
  );
}
export default EditImageButton;
